var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm._t(
        "default",
        function () {
          return [
            _vm.label
              ? _c("label", [
                  _vm._v(" " + _vm._s(_vm.label) + " "),
                  _vm.required
                    ? _c("span", { staticClass: "text-danger" }, [
                        _vm._v(" * "),
                      ])
                    : _vm._e(),
                ])
              : _vm._e(),
            _c(
              "div",
              { staticClass: "uploader-grid-container" },
              [
                _vm._l(_vm.model, function (file) {
                  return _c(
                    "div",
                    {
                      key: file,
                      staticClass:
                        "upload-item user-select-none cursor-pointer",
                    },
                    [
                      file.match(/\.(jpeg|jpg|png)$/) !== null
                        ? _c("brb-media", {
                            staticStyle: {
                              width: "100px",
                              height: "100px",
                              "object-fit": "cover",
                            },
                            attrs: {
                              src: file,
                              width: "100",
                              height: "100",
                              "show-image-preview": "",
                            },
                          })
                        : _c(
                            "div",
                            {
                              staticClass:
                                "d-flex flex-column align-items-center justify-content-center w-100 h-100",
                              staticStyle: { gap: "8px" },
                              on: {
                                click: function ($event) {
                                  return _vm.openStaticLink(file)
                                },
                              },
                            },
                            [
                              _c("font-awesome-icon", {
                                attrs: { icon: "file", size: "2x" },
                              }),
                              _c("span", { staticClass: "text-muted sm" }, [
                                _vm._v(_vm._s(file.split(".").pop())),
                              ]),
                            ],
                            1
                          ),
                      _c(
                        "div",
                        {
                          staticClass: "remove-file",
                          on: {
                            click: function ($event) {
                              return _vm.remove(file)
                            },
                          },
                        },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: "trash-can" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                }),
                _vm.showBrowseButton
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "upload-item dashed-border d-flex flex-column align-items-center justify-content-center user-select-none cursor-pointer",
                        staticStyle: { gap: "8px" },
                        attrs: { "tab-index": _vm.tabIndex },
                        on: { click: _vm.browse },
                      },
                      [
                        _vm.uploading
                          ? [
                              _c("b-progress", {
                                staticClass: "align-self-stretch mx-3",
                                attrs: {
                                  value: _vm.uploadProgress,
                                  variant: "brb-secondary",
                                },
                              }),
                              _c("span", { staticClass: "small" }, [
                                _vm._v(_vm._s(_vm.uploadProgress)),
                              ]),
                            ]
                          : [
                              _c("font-awesome-icon", {
                                attrs: { icon: "plus", size: "lg" },
                              }),
                              _c("span", { staticClass: "small" }, [
                                _vm._v(
                                  " " + _vm._s(_vm.$t("forms.chooseFile")) + " "
                                ),
                              ]),
                            ],
                      ],
                      2
                    )
                  : _vm._e(),
              ],
              2
            ),
            _vm.computedErrors.length
              ? _c(
                  "ul",
                  { staticClass: "px-0 py-2" },
                  _vm._l(_vm.computedErrors, function (error, index) {
                    return _c(
                      "li",
                      {
                        key: `error-${index}`,
                        staticClass: "text-danger small",
                        staticStyle: { "list-style": "none" },
                      },
                      [_vm._v(" " + _vm._s(error) + " ")]
                    )
                  }),
                  0
                )
              : _vm._e(),
          ]
        },
        {
          browse: _vm.browse,
          model: _vm.model,
          uploading: _vm.uploading,
          remove: _vm.remove,
          removeAll: _vm.removeAll,
        }
      ),
      _c("input", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: false,
            expression: "false",
          },
        ],
        ref: "hidden-file-input",
        attrs: {
          type: "file",
          accept: _vm.inputAccept,
          multiple: _vm.multiple,
        },
        on: { change: _vm.onFileInputChange },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }